<template>
  <!-- 预览图 -->
  <AttrGroup>
    <template #title>
      <div class="flex justify-between w-full">
        <div>
          小部件预览图
          <a-tooltip
            :title="'预览图必须上传，' + '预览图尺寸=正常尺寸*' + scale"
          >
            <icon :icon="'help.svg'" :width="20" :height="20" fill="none" />
          </a-tooltip>
        </div>
        <div v-if="shape.children?.length > 1">
          <a-button :size="'small'" @click="creatAllPreview">批量生成</a-button>
        </div>
      </div>
    </template>

    <!-- 缩放提示 -->
    <!-- <SlotPreviewScaleDesc image-type="预览图" /> -->

    <template
      v-for="(item, index) in widgets.filter((item) => item.value != 'none')"
      :key="item.label + index"
    >
      <AttrImage
        :label="item.label"
        class="mb-2.5"
        :base64="getWidgetImage(item.value, 'widgetPreview')"
        :disabled="attrDisabled == 'not-image'"
        :auto-generate="shape.children?.length > 1"
        :show-preview-if-empty="true"
        @change="(image: string) => onPreviewImageUpdate(item.value,image)"
        @delete="() => onPreviewImageDelete(item.value)"
        @auto-generate="() => onPreviewGenarate(item.value)"
      />
    </template>
  </AttrGroup>
</template>
<script lang="ts" setup>
import { useSlotPreview } from '@/hooks';
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { showLoading } from '@/utils/loading.utils';
import { message, Modal } from 'ant-design-vue';

import { computed, PropType, ref } from 'vue';

const editorStore = useEditorStore();

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});

const watchfaceStore = useWatchfaceStore();

// 获取缩放值
const scale = computed(() => {
  const deviceType = watchfaceStore.deviceType;
  // O61、Q63、Q66 预览图尺寸为正常尺寸100%
  if (['O61', 'Q63', 'Q66'].includes(deviceType)) {
    return '100%';
  }
  const scaleValue = watchfaceStore.watchfaceDevice?.editScale ?? 1;
  return `${Math.floor(scaleValue * 100)}%`;
});

const widgets = computed(() => {
  const res = props.shape.children.map((item) => {
    return {
      label: item.attrs.name,
      value: item.id
    };
  });
  if (props.shape.attrs.includeEmpty) {
    res.push({
      value: 'none',
      label: '无'
    });
  }
  res.reverse();
  return res;
});

// 小部件预览图
const { generateSingleWidgetPreview } = useSlotPreview();
const attrDisabled = computed(() => editorStore.attrDisabled);
const getWidgetImage = (
  widgetId: string,
  resourceName: 'widgetPreview' | 'editBox'
) => {
  const shape = Shape.getShape(widgetId);
  return shape?.getResources({
    resourceName: resourceName,
    colorGroup: editorStore.themeColor?.id ?? '',
    base64: true
  })?.[0];
};

const onPreviewImageUpdate = async (widgetId: string, image: string) => {
  const shape = Shape.getShape(widgetId);
  shape?.uploadResource({
    resourceName: 'widgetPreview',
    colorGroup: editorStore.themeColor?.id ?? '',
    realpath: image,
    dirname: '_widget'
  });
};
const onPreviewImageDelete = async (widgetId: string) => {
  const shape = Shape.getShape(widgetId);
  shape?.deleteResource({
    resourceName: 'widgetPreview',
    colorGroup: editorStore.themeColor?.id ?? ''
  });
};
const validWidgetEditBox = (widgetId: string) => {
  if (widgetId === 'none') return true
  const id = props.shape.attrs.sameEditBox ? props.shape.id : widgetId;
  const editbox = getWidgetImage(id, 'editBox');
  if (!editbox) {
    const widgetName = Shape.getShape(id)?.attrs.name;
    Modal.warning({
      title: '提示',
      content: `请先上传小部件 ${widgetName} 的边框图`,
      okText: '知道了'
    });
    return false;
  }
  return true;
};
const onPreviewGenarate = async (widgetId: string) => {
  if (!validWidgetEditBox(widgetId) || widgetId === 'none') return;
  // 没有await一键生成预览图会失效
  await generateSingleWidgetPreview({
    theme: editorStore.theme as unknown as StoreThemeItem,
    widgetId,
    colorId: editorStore.themeColorId
  });
};

const patchLoading = ref(false);
const creatAllPreview = async () => {
  let loading: ReturnType<typeof showLoading> | undefined;
  try {
    if (patchLoading.value) return;
    patchLoading.value = true;
    // 先判断是否有边框图
    for (const item of widgets.value) {
      const id = item.value;
      if (!validWidgetEditBox(id)) return;
    }

    // 一键生成所有预览图
    loading = showLoading('生成预览图可能需要一段时间，请耐心等待');
    for (const item of widgets.value) {
      await onPreviewGenarate(item.value);
    }
    // 生成完成
    loading(() => {
      message.success('预览图生成完成');
    });
  } catch (error) {
    console.log(error);
    loading?.();
  } finally {
    patchLoading.value = false;
  }
};
</script>
<style scoped lang="less"></style>
